// This address points to a dummy ERC20 contract deployed on Ethereum Mainnet,
// Goerli, Kovan, Rinkeby and Ropsten. Replace it with your smart contracts.
const contractAddresses = {
  // ceaErc20: "0xc1C0472c0C80bCcDC7F5D01A376Bd97a734B8815",
  bekonekoz: "0x9ed9dc8af51d74e638528ececd510dca5fe2a539"
};

export default contractAddresses;
